import * as React from 'react';

import moment from 'moment';

import {UsageFooter} from 'shells/navigation/secondary-sidebar/usage-footer-new';

import {useGetUsageStats} from '../email-marketing/graphql/hooks/use-get-usage-stats';
import {
    getEmailsCountMessage,
    getContactsMessage,
    getUniqueSendsMessage,
} from '../email-marketing/sidebar/footer/helpers';

// The campaigns percentage point in which we promote a plan upgrade
const MARKETING_APPROACH_LIMIT_AMOUNT = 0.9;

export function CampaignsUsageFooter() {
    const {nutshellMarketingStats} = useGetUsageStats();

    if (
        !nutshellMarketingStats ||
        (!nutshellMarketingStats.gate.maxNumberOfEmailsPerMonth &&
            !nutshellMarketingStats.gate.maxNumberOfMarketableContacts)
    ) {
        // We don't have a maximum number of emails or contacts. This indicates
        // either a problem on the backend, or (more likely) this account has no
        // limit on the contacts or number of emails (probably dogfood).
        return null;
    }

    const {maxNumberOfMarketableContacts, maxNumberOfEmailsPerMonth, hasOveragesEnabledFromWebfx} =
        nutshellMarketingStats.gate;
    const {numberOfMarketableContacts, numberOfEmailsSentThisMonth} =
        nutshellMarketingStats.usageStats;

    let message;
    const paidAccountOverSendingLimit =
        maxNumberOfMarketableContacts &&
        maxNumberOfEmailsPerMonth &&
        numberOfEmailsSentThisMonth >= maxNumberOfEmailsPerMonth;
    let usedThisMonth = 0;
    let monthlyLimit = 0;
    if (maxNumberOfMarketableContacts) {
        // We have a maximum number of contacts, which indicates this is a paid
        // account. Therefore, we should show contact info.
        // IMPORTANT: this also encapsulates the unique sends limit for "u" marketing plans (ex: nm-2500u-m)
        message = NutClientConfig.isMarketingCampaignsUniqueDeliveriesSku
            ? getUniqueSendsMessage(
                  numberOfMarketableContacts,
                  maxNumberOfMarketableContacts,
                  hasOveragesEnabledFromWebfx
              )
            : getContactsMessage(
                  numberOfMarketableContacts,
                  maxNumberOfMarketableContacts,
                  hasOveragesEnabledFromWebfx
              );
        usedThisMonth = numberOfMarketableContacts;
        monthlyLimit = maxNumberOfMarketableContacts;
        if (maxNumberOfEmailsPerMonth && paidAccountOverSendingLimit) {
            // This is a paid account that is over their monthly sending limit
            message = `You’ve sent all ${maxNumberOfEmailsPerMonth.toLocaleString()} of your messages for this month. Resume sending when your plan resets on ${moment()
                .startOf('month')
                .add(1, 'month')
                .format('LL')}`;
        }
    } else if (maxNumberOfEmailsPerMonth) {
        // We don't have a limit on the number of contacts, which means that we
        // have to use the limit of emails sent
        message = getEmailsCountMessage(numberOfEmailsSentThisMonth, maxNumberOfEmailsPerMonth);
        usedThisMonth = numberOfEmailsSentThisMonth;
        monthlyLimit = maxNumberOfEmailsPerMonth;
    }

    if (!message) {
        // One last check (only for flow)
        return null;
    }

    const shouldShowLearnMoreLink = Boolean(paidAccountOverSendingLimit);

    return (
        <UsageFooter
            approachingLimitPercent={MARKETING_APPROACH_LIMIT_AMOUNT}
            limit={monthlyLimit}
            type='campaigns'
            usage={usedThisMonth}
            shouldShowLearnMoreLink={shouldShowLearnMoreLink}
            message={message}
        />
    );
}
